const GROUPS = [
  { title: "⚔️ Guerra", color: "text-crimson", cmds: [
    ["!war", "Estado de guerra actual"],
    ["!attacks", "Ataques pendientes"],
    ["!top", "Mejores atacantes"],
    ["!failed", "Ataques fallidos (0/1/2⭐)"],
    ["!cleanup", "Limpieza pendiente"],
  ]},
  { title: "🏰 Clan", color: "text-gold", cmds: [
    ["!clan", "Info del clan"],
    ["!player #TAG", "Info de jugador"],
    ["!capital", "Capital del clan"],
    ["!leaderboard", "Tabla de líderes"],
  ]},
  { title: "📊 Reportes", color: "text-blue-400", cmds: [
    ["!month", "Mes actual"],
    ["!Previousmonth", "Mes anterior"],
    ["!cwltop", "Top CWL"],
    ["!cwlsummary", "Resumen CWL actual"],
  ]},
  { title: "🏆 Rankeds", color: "text-purple-400", cmds: [
    ["!ranked #TAG", "Clasificación jugador (global/local)"],
    ["!rankedclan #TAG", "Clasificación del clan"],
  ]},
  { title: "🔬 Guerra avanzada", color: "text-crimson", cmds: [
    ["!analysis", "Análisis de guerra"],
    ["!forecast", "Pronóstico de victoria"],
  ]},
  { title: "🔔 Avisos", color: "text-emerald-400", cmds: [
    ["!statusnotify", "Estado de avisos"],
    ["!notify on/off", "Activar/desactivar avisos"],
    ["!notify allies/both", "Alcance de avisos"],
    ["!notifymode instant/summary", "Modo de avisos"],
    ["!notifytime=1", "Intervalo del resumen (horas)"],
    ["!membernotice on/off", "Avisos nuevos miembros"],
  ]},
  { title: "🎯 Rival CWL", color: "text-gold", cmds: [
    ["!rival", "Info del rival"],
    ["!rivalfull", "Info completa del rival"],
    ["!rivalsummary", "Resumen rival"],
    ["!rivalmembers", "Miembros del rival"],
    ["!rivalhelp", "Ayuda de rival"],
  ]},
  { title: "⚙️ Admin", color: "text-crimson", cmds: [
    ["!activate <días> #TAG", "Activar plan (admin)"],
    ["!deactivate", "Desactivar plan (admin)"],
    ["!licensestatus", "Estado de la licencia (admin)"],
    ["!licenses", "Ver todas las licencias (admin)"],
  ]},
];

export default function CommandsView() {
  return (
    <div className="space-y-6">
      <div>
        <span className="overline text-gold">Referencia</span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold">Comandos del Bot</h2>
        <p className="text-muted-foreground text-sm mt-1">Escribe <code className="text-gold">!help</code> en el grupo para ver el menú principal.</p>
      </div>

      <div className="card-surface p-3 overflow-hidden" data-testid="menu-image-card">
        <img src="/menu.png" alt="Menú AC WARDEN" className="w-full rounded-md" />
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="commands-grid">
        {GROUPS.map((g) => (
          <div key={g.title} className="card-surface p-5">
            <h3 className={`font-heading font-semibold mb-3 ${g.color}`}>{g.title}</h3>
            <ul className="space-y-2">
              {g.cmds.map(([c, d]) => (
                <li key={c} className="text-sm">
                  <code className="text-white font-mono">{c}</code>
                  <span className="text-muted-foreground block text-xs">{d}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
